export default {
  hidden_rates:
    'Nogle betalingsmetoder har også deres egen sats, som din platformssupport har fastsat. De gælder i stedet for denne sats.',
  title: 'Betalingsgebyrer',
  subtitle: 'Det betalingsgebyr, {{company}} opkræves på onlinebetalinger for at dække Stripes gebyrer.',
  card_title: 'Betalingsgebyr',
  status: {
    inherited_tag: 'Partnerstandard',
    inherited: 'Denne restaurant opkræves dit standardbetalingsgebyr.',
    custom_tag: 'Brugerdefineret',
    custom: 'Denne restaurant har sit eget betalingsgebyr, som erstatter dit standardgebyr.',
    none_title: 'Der er ikke angivet noget betalingsgebyr',
    none: 'Hverken denne restaurant eller din standard har en sats. Medmindre du har bekræftet 0 % margin på partnerens side for betalingsgebyrer, kan den ikke gå live eller modtage onlinebetalinger. Med den bekræftelse opkræves der intet, og du betaler Stripes gebyrer på dens betalinger.',
  },
  buttons: {
    set_custom: 'Angiv brugerdefineret gebyr',
    edit: 'Rediger',
    cancel: 'Annuller',
    save: 'Gem',
    reset_to_default: 'Nulstil til standard',
  },
  toasts: {
    load_error: 'Betalingsgebyret kunne ikke indlæses.',
    failed_to_save_changes: 'Betalingsgebyret kunne ikke gemmes.',
    changes_got_saved: 'Betalingsgebyr gemt',
    reset_to_default: 'Denne restaurant bruger nu dit standardbetalingsgebyr.',
  },
};
